export default __webpack_public_path__ + "static/media/vai.edcbbfdb.svg";